/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
var o;!function(o){o[o.Color=0]="Color",o[o.Depth=1]="Depth",o[o.Normal=2]="Normal",o[o.Shadow=3]="Shadow",o[o.ShadowHighlight=4]="ShadowHighlight",o[o.ShadowExcludeHighlight=5]="ShadowExcludeHighlight",o[o.Highlight=6]="Highlight",o[o.Alpha=7]="Alpha",o[o.ObjectAndLayerIdColor=8]="ObjectAndLayerIdColor",o[o.CompositeColor=9]="CompositeColor",o[o.COUNT=10]="COUNT"}(o||(o={}));export{o as ShaderOutput};
